import { createSlice } from "@reduxjs/toolkit";
import { getAnalyticsAPI } from "../../services/analytics";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const appDownloadSlice = createSlice({
  name: "appDownloadDetails",
  initialState: data,
  reducers: {
    appDownloadInfo(state) {
      state.isLoading = true;
    },
    appDownloadInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    appDownloadInfoFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
      state.data = null;
    },
    appDownloadInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const appDownloadDataHandler = (data) => async (dispatch) => {
  try {
    dispatch(appDownloadAction.appDownloadInfo());
    const response = await getAnalyticsAPI(data);
    dispatch(appDownloadAction.appDownloadInfoSuccess(response));
  } catch (e) {
    dispatch(appDownloadAction.appDownloadInfoFailure(e));
  }
};
export default appDownloadSlice.reducer;
export const appDownloadAction = appDownloadSlice.actions;
